export default __webpack_public_path__ + "static/073-ec534d30e531784efd1669c2b226f676.jpg";